import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb' }}>
      <nav className="nav-header">
        <div className="nav-logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
          <img 
            src="https://customer-assets.emergentagent.com/job_returnpal-pickup/artifacts/x8ux114u_Screenshot%202026-04-27%20165324.png" 
            alt="ReturnPal" 
            className="logo-image" 
            style={{ height: "50px", width: "auto" }}
          />
        </div>
        <Button onClick={() => navigate(-1)} variant="outline">
          <ArrowLeft size={16} style={{ marginRight: '0.5rem' }} />
          Back
        </Button>
      </nav>

      <div style={{ maxWidth: '900px', margin: '2rem auto', padding: '0 2rem' }}>
        <div style={{ backgroundColor: 'white', borderRadius: '8px', padding: '3rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '1rem', color: '#1f2937' }}>
            Privacy Policy
          </h1>
          <p style={{ color: '#6b7280', marginBottom: '2rem' }}>Effective Date: April 1, 2026</p>

          <p style={{ lineHeight: '1.8', color: '#4b5563', marginBottom: '2rem' }}>
            This Privacy Policy describes how ReturnPal ("Company," "we," "us," or "our") collects, uses, discloses, and safeguards personal information obtained from customers ("Customer," "you," or "your") in connection with the use of ReturnPal services.
          </p>

          <p style={{ lineHeight: '1.8', color: '#4b5563', marginBottom: '2rem', fontWeight: '600' }}>
            By accessing or using ReturnPal services, you acknowledge and agree to the terms of this Privacy Policy.
          </p>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>1. Information We Collect</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563', marginBottom: '0.5rem' }}>
              We may collect the following categories of information:
            </p>
            
            <h3 style={{ fontSize: '1.125rem', fontWeight: '600', marginTop: '1rem', marginBottom: '0.5rem', color: '#4b5563' }}>Personal Information</h3>
            <ul style={{ marginLeft: '2rem', lineHeight: '1.8', color: '#4b5563' }}>
              <li>Full name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Billing and payment information</li>
            </ul>

            <h3 style={{ fontSize: '1.125rem', fontWeight: '600', marginTop: '1rem', marginBottom: '0.5rem', color: '#4b5563' }}>Service Information</h3>
            <ul style={{ marginLeft: '2rem', lineHeight: '1.8', color: '#4b5563' }}>
              <li>Pickup and drop-off locations</li>
              <li>Package count and service details</li>
              <li>Booking history and transaction data</li>
            </ul>

            <h3 style={{ fontSize: '1.125rem', fontWeight: '600', marginTop: '1rem', marginBottom: '0.5rem', color: '#4b5563' }}>Technical Information</h3>
            <ul style={{ marginLeft: '2rem', lineHeight: '1.8', color: '#4b5563' }}>
              <li>IP address</li>
              <li>Device information</li>
              <li>Browser type and usage data (if applicable)</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>2. How We Use Information</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563', marginBottom: '0.5rem' }}>
              We use collected information for the following purposes:
            </p>
            <ul style={{ marginLeft: '2rem', lineHeight: '1.8', color: '#4b5563' }}>
              <li>To provide, operate, and fulfill ReturnPal services</li>
              <li>To process transactions and payments</li>
              <li>To communicate with customers regarding bookings, updates, and support</li>
              <li>To improve service performance and customer experience</li>
              <li>To enforce our Terms of Service and prevent misuse</li>
              <li>To comply with legal obligations</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>3. Sharing of Information</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563', fontWeight: '600', marginBottom: '0.5rem' }}>
              We do not sell or rent personal information.
            </p>
            <p style={{ lineHeight: '1.8', color: '#4b5563', marginBottom: '0.5rem' }}>
              We may share information with:
            </p>
            <ul style={{ marginLeft: '2rem', lineHeight: '1.8', color: '#4b5563' }}>
              <li>Payment processors for secure transaction handling</li>
              <li>Shipping carriers as necessary to complete return deliveries</li>
              <li>Service providers assisting with operations, communications, or technical infrastructure</li>
              <li>Legal authorities when required by law or to protect our rights and safety</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>4. Data Security</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563' }}>
              We implement commercially reasonable safeguards to protect personal information. However, no method of transmission or storage is completely secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>5. Data Retention</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563', marginBottom: '0.5rem' }}>
              We retain personal information only as long as necessary to:
            </p>
            <ul style={{ marginLeft: '2rem', lineHeight: '1.8', color: '#4b5563' }}>
              <li>Fulfill services</li>
              <li>Comply with legal obligations</li>
              <li>Resolve disputes</li>
              <li>Enforce agreements</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>6. Your Rights</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563', marginBottom: '0.5rem' }}>
              You may request to:
            </p>
            <ul style={{ marginLeft: '2rem', lineHeight: '1.8', color: '#4b5563' }}>
              <li>Access your personal data</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your data (subject to legal requirements)</li>
            </ul>
            <p style={{ lineHeight: '1.8', color: '#4b5563', marginTop: '0.5rem' }}>
              Requests may be submitted by contacting ReturnPal directly.
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>7. Third-Party Services</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563' }}>
              ReturnPal may rely on third-party providers (such as payment processors or communication platforms). These providers operate under their own privacy policies, and ReturnPal is not responsible for their practices.
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>8. Children's Privacy</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563' }}>
              ReturnPal services are not intended for individuals under the age of 18. We do not knowingly collect personal information from minors.
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>9. Updates to This Policy</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563' }}>
              We reserve the right to modify this Privacy Policy at any time. Updates will be posted with a revised effective date. Continued use of services constitutes acceptance of any changes.
            </p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1rem', color: '#374151' }}>10. Contact Information</h2>
            <p style={{ lineHeight: '1.8', color: '#4b5563' }}>
              For questions or requests regarding this Privacy Policy, please contact:
            </p>
            <p style={{ lineHeight: '1.8', color: '#4b5563', marginTop: '1rem' }}>
              <strong>ReturnPal Support</strong><br />
              Support@GetReturnPal.com
            </p>
          </section>

          <div style={{ 
            marginTop: '3rem', 
            padding: '1.5rem', 
            backgroundColor: '#eff6ff', 
            borderRadius: '8px', 
            border: '2px solid #3b82f6' 
          }}>
            <p style={{ fontWeight: '600', color: '#1e40af', marginBottom: '0.5rem' }}>Your Privacy Matters</p>
            <p style={{ color: '#1e3a8a', lineHeight: '1.6' }}>
              By using ReturnPal services, you acknowledge that you have read and understood this Privacy Policy.
              <br />
              <strong>Governed by the laws of the State of Arizona</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
